export * from './MaterialsListItemLightboxFavoriteButton.types';
export { default as MaterialsListItemLightboxFavoriteButton } from './MaterialsListItemLightboxFavoriteButton';
